import { createContext } from "react";
import useBooking from "lib/hooks/useBookingContext";

const BookingContext = createContext<BookingState>(null);

const BookingContextProvider = ({ children }: ComponentProps) => {
  return (
    <BookingContext.Provider value={useBooking()}>
      {children}
    </BookingContext.Provider>
  );
};

export { BookingContext, BookingContextProvider };
